function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import React from "react";
import { render, unmountComponentAtNode } from "react-dom";
import { components } from "@reactivepad/core";
import { pluginKey, TRANSACTION_METAS } from "../config";

var Table = components.Table;

var TableView = function () {
  function TableView(tableRenderDelay, node, editorView, getPos) {
    var _this = this;

    _classCallCheck(this, TableView);

    var id = node.attrs.id;

    var store = pluginKey.getState(editorView.state);
    var table = store.findById(id);
    this.dom = document.createElement("div");

    this.snapshotDisposer = table.onSnapshot(function (snapshot) {
      editorView.dispatch(editorView.state.tr.setMeta(TRANSACTION_METAS.nodeSnapshot, true).setNodeMarkup(getPos(), undefined, snapshot));
    });

    // ToDo: timeout needed so that table properly renders; is there a better way?
    this.timeoutId = setTimeout(function () {
      render(React.createElement(Table, { node: table, tableRenderDelay: tableRenderDelay }), _this.dom);
    });
  }

  TableView.prototype.stopEvent = function stopEvent() {
    return true;
  };

  TableView.prototype.ignoreMutation = function ignoreMutation() {
    return true;
  };

  TableView.prototype.update = function update() {
    // if returning false (or this function absent) component is unnecessary remounted
    return true;
  };

  TableView.prototype.destroy = function destroy() {
    clearTimeout(this.timeoutId);
    this.snapshotDisposer();
    unmountComponentAtNode(this.dom);
  };

  return TableView;
}();

export default TableView;